// removed by extract-text-webpack-plugin
module.exports = {"mainDiv":"sbb4wDA9mN395LUM67P7b","mainImg":"_C9FS_GihBSVJ2_ib74gP","subtitle":"sai6ZF-esSnGtxnnkKx7N","text":"_1G29EnxscXWSdSOXUJYRTj","spacer":"oZ4gZ0fF-zqLcj38jyehp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Cienie/Cienie.css
// module id = 45
// module chunks = 0